module.exports = __webpack_public_path__ + "static/media/flashoff.2527c738.svg";